import { LayoutSettingsDTOModeEnum } from '@neptune/shared/core-apis-leaderboard-domain';

import { invertMapTyped } from 'common/tsHelpers';

export enum WidgetLayoutMode {
  Grid = 'grid',
  Custom = 'custom',
}

const widgetLayoutModeTypeMapping: Record<
  LayoutSettingsDTOModeEnum,
  (typeof WidgetLayoutMode)[keyof typeof WidgetLayoutMode]
> = {
  GRID: WidgetLayoutMode.Grid,
  CUSTOM: WidgetLayoutMode.Custom,
};

const invertedWidgetLayoutModeTypeMapping = invertMapTyped(widgetLayoutModeTypeMapping);

export const widgetLayoutModeFromApiToDomain = (
  layoutMode?: LayoutSettingsDTOModeEnum,
): WidgetLayoutMode => {
  if (layoutMode) {
    return widgetLayoutModeTypeMapping[layoutMode] ?? DEFAULT_WIDGET_LAYOUT_SETTINGS.mode;
  }

  return DEFAULT_WIDGET_LAYOUT_SETTINGS.mode;
};

export const widgetLayoutModeFromDomainToApi = (
  layoutMode: WidgetLayoutMode,
): LayoutSettingsDTOModeEnum =>
  invertedWidgetLayoutModeTypeMapping[layoutMode] ??
  (DEFAULT_WIDGET_LAYOUT_SETTINGS.mode.toUpperCase() as LayoutSettingsDTOModeEnum);

export enum WidgetLayoutGridModeColumnsCount {
  Responsive = 'Responsive',
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
  Five = '5',
  Six = '6',
}

const gridModeColumnsCountMapping: Record<
  string,
  (typeof WidgetLayoutGridModeColumnsCount)[keyof typeof WidgetLayoutGridModeColumnsCount]
> = {
  Responsive: WidgetLayoutGridModeColumnsCount.Responsive,
  '1': WidgetLayoutGridModeColumnsCount.One,
  '2': WidgetLayoutGridModeColumnsCount.Two,
  '3': WidgetLayoutGridModeColumnsCount.Three,
  '4': WidgetLayoutGridModeColumnsCount.Four,
  '5': WidgetLayoutGridModeColumnsCount.Five,
  '6': WidgetLayoutGridModeColumnsCount.Six,
};

export const gridModeColumnsCountFromApiToDomain = (
  columnsCount: string,
): WidgetLayoutGridModeColumnsCount => {
  return (
    gridModeColumnsCountMapping[columnsCount] ??
    DEFAULT_WIDGET_LAYOUT_SETTINGS.config.gridMode.columnsCount
  );
};

export type WidgetLayoutConfig = {
  gridMode: {
    columnsCount?: WidgetLayoutGridModeColumnsCount;
  };
};

type GlobalWidgetLayoutConfig = {
  gridMode: {
    columnsCount: WidgetLayoutGridModeColumnsCount;
  };
};

export type WidgetLayoutSettings = {
  mode?: WidgetLayoutMode;
  config: WidgetLayoutConfig;
};

export type GlobalWidgetLayoutSettings = {
  mode: WidgetLayoutMode;
  config: GlobalWidgetLayoutConfig;
};

export type ResolvedWidgetLayoutSettings = GlobalWidgetLayoutSettings;

export const DEFAULT_WIDGET_LAYOUT_SETTINGS: GlobalWidgetLayoutSettings = {
  mode: WidgetLayoutMode.Custom,
  config: {
    gridMode: {
      columnsCount: WidgetLayoutGridModeColumnsCount.Responsive,
    },
  },
};

export const GRID_LAYOUT_WIDGET_HEIGHT = 6;
